import { useState } from 'react';
import * as Sentry from '@sentry/react';
import { useSubscription } from '@apollo/client/react';

import { RepoUploadVerificationFinishedDocument } from 'src/graphql/actions/repoUploads/repoUploadVerificationFinished.subscription';

const useRepoVerification = (onComplete?: () => void, onFailure?: () => void) => {
  const [verificationAssetId, setVerificationAssetId] = useState<string | null>(null);
  const [isVerifying, setIsVerifying] = useState(false);

  const { data: verificationData } = useSubscription(RepoUploadVerificationFinishedDocument, {
    variables: { assetId: verificationAssetId || '' },
    skip: !verificationAssetId || !isVerifying,
    onData: ({ data }) => {
      if (data.data?.repoUploadVerificationFinished) {
        const result = data.data.repoUploadVerificationFinished;
        if (result.success) {
          setIsVerifying(false);
          setVerificationAssetId(null);
          onComplete?.();
        } else {
          setIsVerifying(false);
          setVerificationAssetId(null);
          onFailure?.();
        }
      }
    },
    onError: (err) => {
      Sentry.captureException(err);
      setIsVerifying(false);
      setVerificationAssetId(null);
      onFailure?.();
    },
  });

  const startVerification = (assetId: string) => {
    setVerificationAssetId(assetId);
    setIsVerifying(true);
  };

  const stopVerification = () => {
    setIsVerifying(false);
    setVerificationAssetId(null);
  };

  return {
    isVerifying,
    startVerification,
    stopVerification,
    verificationData,
  };
};

export default useRepoVerification;
